import React, { FC, useContext, useEffect, useRef, useState } from "react";
import "./DelayEntry.scss";
import { AuthContext } from "../../providers/AuthProvider";
import {
  
  GetFltopsDelayData,
  GetMaintDelayDetail,
  SaveFlightDelayDetail,  
  GetArrivalFlightDetail,
  GetMaintDelays,
  ValidateLogPageNumber,
  UpdateDelayCode} from "../../services/DelayListService/DelayListService";
import { DCTextArea } from "../Wrappers/DCTextArea";
import { DCSelect } from "../Wrappers/DCSelect";
import { DCDatePicker } from "../Wrappers/DCDatePicker";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import { FlightDelayDetail } from "../../Model/FlightDelayDetail";
import Alert from "../Alert/Alert";
import { AircaftData } from "../../Model/AircraftData";
import { AircraftInput } from "../AircraftInput/AircraftInput";
import { ConfirmDeletePopUp } from "../ConfirmDeletePopUp/ConfirmDeletePopUp";
import { DCDialog } from "../Wrappers/DCDialog";
import { TraxLogInfo } from "../TraxLogInfo/TraxLogInfo";
import { DCInput } from "../Wrappers/DCInput";
import { useSelector } from "react-redux";
import { DelayListRecordWithAction } from "../../Model/DelayListRecordWithAction";
import { UpdateDelayCodeModel } from "../../Model/UpdateDelayCodeModel";
import { toTrimmedString, extractDatePart } from "../../utils/utils";

interface DelayEntryDataFormProps {
  onCancel: () => void;
  onError: (data: string) => void;
  onDelete: (id: string,aircraft:string,station:string,deptFlight:string)=>void;
  aircraft: string;
  flight: string;
  station: string;
  searchDate: string;
  airline: string;
  source: string;
  MaintDncId:string;
  delayTimeLen:string;
  scheddepart:string;
  actualdepart:string;
  closeDialog: () => void;
  onSaveFlightDelayDetail: (savedRecord: DelayListRecordWithAction) => void;
  flightSegmentId?: number;
}
function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}
export const DelayEntry: FC<DelayEntryDataFormProps> = ({  
  onCancel,
  onError,
  onDelete,
  aircraft,
  flight,
  station,
  searchDate,
  airline,
  source,
  MaintDncId,
  delayTimeLen,
  scheddepart,
  actualdepart,
  closeDialog,
  onSaveFlightDelayDetail,
  flightSegmentId: providedFlightSegmentId,
}) => {
  
  
  //Constants

  const {
    getAccessToken,
    getAdminStatus,
    getMaintainerStatus,
  } = useContext(AuthContext);
  const lengthofdelayPattern = "^([01][0-9]|2[0-3]):[0-5][0-9]$";
  const flightTimePattern = "^$|^([01][0-9]|2[0-3])[0-5][0-9]$";
  const flightTimeValidationMessage = "Please enter a valid time in HHMM format";
  const carrier = "";
  const [defectType, setDefectType] = useState(""); // <-- Move to state if needed, or set as appropriate
  let allConditionsMet = false;
  let patternConditionsMet = false;
  //States
  const [busy, setBusy] = useState(false);
  const [loadingMEData, setLoadingMEData] = useState(false);
  const [delaycode, setdelaycode] = useState("D01");
  const [interrupttype, setinterrupttype] = useState("F");
  const [fleet, setfleet] = useState("1");
  const [delay, setDelay] = useState("");
  const [fltopsC, setFltopsC] = useState("");
  const delaycodemodel = useSelector((state: any) => state.delayCodesState.delayCodes);
  const aircraftList = useSelector((state: any) => state.aircraftState.aircraftList);   
  const [lastUpdatedBy, setLastUpdatedBy] = useState("");
  const [lastUpdatedOn, setLastUpdatedOn] = useState("");
  const [aircraftvalue, setAircraftValue] = useState(aircraft);
  const [depflightvalue, setDepFlightValue] = useState(flight);
  const [stationvalue, setStationValue] = useState(station);
  const [searchdatevalue, setSearchDateValue] = useState(searchDate);
  const [arrivalflightnumber, setArrivalFlightNumber] = useState("");
  const [arrivalscheduledtime, setArrivalScheduledTime] = useState("");
  const [arrivalactualtime, setArrivalActualTime] = useState("");
  const [departurescheduledtime, setDepartureScheduledTime] = useState("");
  const [departureactualtime, setDepartureActualTime] = useState("");
  const [lengthofdelay, setLengthOfDelay] = useState("");
  const [maintenanceinterruptcomment, setMaintenanceInterruptComment] = useState("");
  const [mechanicalfailind, setMechanicalFailInd] = useState("Y");
  const [firstdelayind, setFirstDelayInd] = useState("Y");
  const [logPagenumber, setLogPageNumber] = useState("");
  const [itemNumber, setItemNumber] = useState("");
  const [atachapter, setAtaChapter] = useState("");
  const [traxFlightNumber, setTraxFlightNumber] = useState("");
  const [discrepancycomments, setDiscrepancyComments] = useState("");
  const [correctioncomments, setCorrectionComments] = useState("");
  const [flightSegmentId, setFlightSegmentId] = useState(0);
  const [isapiresponsereceived, setIsapiresponsereceived] = useState(false);
  const [isAircraftValid, setIsAircraftValid] = useState(true);
  const [airlineCode, setAirlineCode] = useState(airline);
  const [isLogPageValid, setIsLogPageValid] = useState(true);
  const [sourceValue, setSourceValue] = useState(source);
  const [showLoader , setShowLoader] = useState(false);
  const[enableDeleteBtn,setEnableDeleteBtn]=useState(false);
  const [openDeleteDialog, setDeleteDialogOpen] = useState(false); 
  const [alertType, setAlertType] = useState<string>("information");
  const [alertMsg, setAlertMessage] = useState<string>("M&E Delay and Cancellation initialized.");
  const [page, setPage] = useState<string>("Delay Details");
  const [traxCommentMismatch, setTraxCommentMismatch] = useState<boolean>(false);
  const [delayCodeMessage,setdelayCodeMessage]=useState("");
  const [showDCCodeAlert,setShowDCCodeAlert]=useState(false);
  const [delaycodevalue,  setDelayCodeValue] = useState("");
  const [manufacturerId, setManufacturerId] = useState(Number);
  const [manufacturerCode, setManufacturerCode] = useState("");
  const [isNon737Tail, setIsNon737Tail] = useState(false);
  const [flightSegIdPrev,setFlightSegIdPrev]=useState(0);
  const prevDateInputValue = usePrevious(searchdatevalue);
  const [onSaveFieldValidations, setOnSaveFieldValidations] = useState(false);
  const [isDCInputValid, setIsDCInputValid] = useState(false);
  const [hasAircraftValidationApiError, setHasAircraftValidationApiError] = useState(false);
  const [formattedLastUpdatedOn, setFormattedLastUpdatedOn] = useState<string>("");
  const [isInitiallyUncodedTraxRecord, setIsInitiallyUncodedTraxRecord] = useState(false);
  const [isItemFocused, setIsItemFocused] = useState(false);
  const [isLogFocused, setIsLogFocused] = useState(false);
  const [isTraxCompareInProgress, setIsTraxCompareInProgress] = useState(false);
    // Track validity of each DCInput
  const dcInputValidity = useRef<{ [key: string]: boolean }>({});
  const latestCompareInputsRef = useRef({ logPagenumber: "", manufacturerCode: "", itemNumber: "" });
  const compareRequestIdRef = useRef(0);
  const pendingCompareRequestsRef = useRef(0);
  // Track the log+item that was originally loaded from M&E so we can detect user changes
  const initialLogPageNumberRef = useRef<string>("");
  const initialItemNumberRef = useRef<string>("");

  // Keep latest compare tuple in sync during render so async handlers always
  // read current values, even before effects flush.
  latestCompareInputsRef.current = { logPagenumber, manufacturerCode, itemNumber };

  const handleValidityChange = (key: string, isValid: boolean) => {
    dcInputValidity.current[key] = isValid;
    // Update overall validity
    const overallValidity = Object.values(dcInputValidity.current).every(Boolean);
    setIsDCInputValid(overallValidity);
  };

  const handleBlurForDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDateValue = e.currentTarget.value;
    if (newDateValue !== prevDateInputValue) {
      getMaintDelayDetails(newDateValue);
      setSearchDateValue(newDateValue);
    }
  };
  /*** Refs ***/
  const mechanicalfailindGroupEl = useRef(null);
  const firstdelayindGroupEl = useRef(null);

  /***Effects***/
  //Effect to enable/disable save button: called on every state change
  useEffect(() => {    
    
     if(sourceValue === 'M&E')
    {
      setEnableDeleteBtn(true);
    }
  });
  useEffect(() => {
    // Check if the aircraft value exists in the aircraftList
    if (aircraft && aircraftList.length > 0) {
      const matchedAircraft = aircraftList.find(
        (item: AircaftData) => item.aircraftReg === "N" + aircraft
      );
  
      if (matchedAircraft) {
        // Set airline and numeric manufacturer ID from aircraft data
        setAirlineCode(matchedAircraft.airlineCode);
        setManufacturerId(matchedAircraft.manufacturerId);
        setIsNon737Tail(matchedAircraft.IsHaTail);
  
        // Set TRAX manufacturer code used by log-page validation API
        // IsHaTail=true means non-737 (HA), IsHaTail=false means 737 (AS/VX)
        if (matchedAircraft.IsHaTail) {
          // Non-737: HA tail
          setManufacturerCode("HA");
        } else {
          // 737: AS based on manufacturerId
          if (matchedAircraft.manufacturerId === 1) {
            setManufacturerCode("AS");
          }
        }
      } else {
        // Handle case where no match is found
        console.log("No matching aircraft found in the list.");
      }
    }
  }, [aircraft, aircraftList]);
  //Effect to handle mechanical failure radio group change: called on every state change
  useEffect(() => {    
    const flierGroup: any = mechanicalfailindGroupEl.current;
    if (flierGroup) {
      flierGroup.addEventListener("change", handleMechanicalfailindGroup);
      return function cleanup() {
        flierGroup.removeEventListener("change", handleMechanicalfailindGroup);
      };
    }
  });

  //Effect to handle first delay radio group change: called on every state change  
  useEffect(() => {
    const flierGroup: any = firstdelayindGroupEl.current;
    if (flierGroup) {
      flierGroup.addEventListener("change", handleFirstDCFailureGroup);
      return function cleanup() {
        flierGroup.removeEventListener("change", handleFirstDCFailureGroup);
      };
    }
  });

  //Effect to handle Trax compare trigger when log page / manufacturer / item number changes
  useEffect(() => { 
    const isPrivilegedUser = getAdminStatus().value || getMaintainerStatus().value;
    if (!isPrivilegedUser) {
      return;
    }


    // Keep compare API quiet while user is still editing log/item fields.
    if (isItemFocused || isLogFocused) {
      console.log('DelayEntry.useEffect[compare]: skipping - field is focused');
      return;
    }

    const hasBaseRequiredFields = logPagenumber.trim() !== "" && manufacturerCode.trim() !== "";
    const hasRequiredFields = isNon737Tail ? hasBaseRequiredFields && itemNumber.trim() !== "" : hasBaseRequiredFields;

    if (hasRequiredFields) {
      console.log('DelayEntry.useEffect[compare]: ✓ calling CompareTraxData');
      CompareTraxData();
    } else {
      console.log('DelayEntry.useEffect[compare]: ✗ missing required fields', {
        hasBaseRequiredFields,
        hasRequiredFields
      });
    }
    // NOTE: isLogFocused and isItemFocused are both in the dependency array so that
    // when the user finishes editing (field blur → focused=false), this effect re-fires
    // and CompareTraxData runs with the new value. Refresh clicks may also cause blur,
    // so this focus-gating suppresses compares while editing but allows them after blur.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logPagenumber, manufacturerCode, itemNumber, isNon737Tail, isItemFocused, isLogFocused]);

  //Effect called on component load.
  useEffect(() => {
    console.log("useEffect: Component load");
    //Load delay codes
    try {
      //Set busy flag to true.
      setBusy(true);
      setShowLoader(true);

      //Validate delaycodemodel
      if (!delaycodemodel || delaycodemodel.length === 0) {
        setShowDCCodeAlert(true);
        setdelayCodeMessage("No delaycodes found")
      } else {
        setDelayCodeValue(delaycodemodel[0].DelayCode);
      }


    //Get delay details from fltops or M&E.
    if (station !== "") {   
      //Get Entry details from fltops Or M&E.
      if (sourceValue === "FltOpsC" || sourceValue === "FltOpsD") {        
        // Use the provided flightSegmentId instead of fetching from GetFlightSegmentInfo
        if (providedFlightSegmentId && providedFlightSegmentId > 0) {
          console.log("Using provided FlightSegmentId:", providedFlightSegmentId);
          setFlightSegmentId(providedFlightSegmentId);
          setFlightSegIdPrev(providedFlightSegmentId);
          getArrivalFlightInfo(providedFlightSegmentId); 
          setLengthOfDelay(delayTimeLen);   
          setDepartureScheduledTime(scheddepart);   
          setDepartureActualTime(actualdepart);  
          
          //get the Visops DELAY or CANCEL code from FlightOps
          getFltopsDelayData(providedFlightSegmentId);
        } else {
          onError("No flight segment ID provided from delay list");
        }
        setBusy(false);
      } else if (sourceValue === "M&E") {
        getMaintDelayDetails(searchDate);
      }
    }
  }
  catch(error)
  {
   console.log(error);
   setIsapiresponsereceived(true);
    setAlertType("error");
        setAlertMessage(extractDetailsFromErrorMessage(error));
        setPage("Delay Details");
  }
    finally {
     setBusy(false);
    setShowLoader(false); 
  }
  }, []);

  useEffect(() => {
    
    const conditions = [
      stationvalue,
      aircraftvalue,
      depflightvalue,
      searchdatevalue,
      arrivalflightnumber,
      lengthofdelay,
      interrupttype,
      delaycode,
      mechanicalfailind,
      firstdelayind,
      discrepancycomments,
      correctioncomments, 
    ];
    allConditionsMet = false;
    allConditionsMet = conditions.every((value) =>value !=null && value.trim() !== "");

    const patternConditions=[
      arrivalactualtime,
      arrivalscheduledtime,
      departureactualtime,
      departurescheduledtime
    ]
    patternConditionsMet = false;
    patternConditionsMet = patternConditions.every((value) => new RegExp(flightTimePattern).test(value));
  }) 
    
     //***Functions*****
  const checkValidations = () => {
    setIsapiresponsereceived(false);
    setAlertType("");
    setAlertMessage("");
    setPage("");

    if (allConditionsMet && patternConditionsMet) {
      if (
        (lengthofdelay !== "" && !new RegExp(lengthofdelayPattern).test(lengthofdelay)) ||
        !isAircraftValid ||
        showDCCodeAlert || !isDCInputValid
      ) {
        console.log("Validation failed");
      } else {
        saveFlightDelayDetail();
      }
    } else {
      setOnSaveFieldValidations(true);
    }
  }
  
  /**
   * Extracts the YYYY-MM-DD portion from an ISO-8601 date/time string (e.g. "2024-06-20T12:00:00Z").
   * @param dateString Input date string.
   * @returns YYYY-MM-DD, or "" if the input does not start with a YYYY-MM-DD date.
   */

  
  //Save delay details function.
  const saveFlightDelayDetail = () => {
    setBusy(true);
    setIsapiresponsereceived(false);

    const date = parse(searchdatevalue, "yyyy-MM-dd", new Date());
    const formattedDate = format(date, "ddMMMyy").toUpperCase();

    const flightdelaydetail: FlightDelayDetail = {
      Carrier: carrier,
      defectType: defectType,
      manufacturer: manufacturerId.toString(),
      FlightSegmentId: flightSegmentId,
      FlightSegmentIdPrev: flightSegIdPrev,
      DelayStation: stationvalue,
      AircraftReg: aircraftvalue,
      FlightNumber: depflightvalue,
      FlightDate: formattedDate,
      ArrivalFlightNumber: arrivalflightnumber,
      ArrivalScheduledTime: arrivalscheduledtime,
      ArrivalActualTime: arrivalactualtime,
      DelayCanxIndicator: delaycode.startsWith("C") ? "C" : "D",
      DepartureFlightNumber: depflightvalue,
      DepartureScheduledTime: departurescheduledtime,
      DepartureActualTime: departureactualtime,
      LengthOfDelay: lengthofdelay,
      ReportedUpdatedBy: "",
      InterruptIndicator: interrupttype,
      MaintenanceInterruptComment: maintenanceinterruptcomment,
      WhenReportedComment: "",
      DelayCode: delaycode,
      LogPageNumber: logPagenumber,
      ItemNumber: itemNumber,
      AtaChapter: atachapter,
      LogReportedByEmployee: "",
      DiscrepancyComments: discrepancycomments,
      CorrectionComments: correctioncomments,
      DateLastUpdated: new Date().toISOString(),
      MechanicalFailInd: mechanicalfailind,
      FirstDelayInd: firstdelayind,
      ReturnInd: "",
      TraxFlightNumber: traxFlightNumber,
      REPORT_UPDATED_PEOPLESOFTID: "",
      REPORT_UPDATED_GIVENNAME: "",
      REPORT_UPDATED_FAMILYNAME: "",
    };

    SaveFlightDelayDetail(getAccessToken(), flightdelaydetail)
      .then((response) => {
        console.info(response);
        setAlertType("success");
        setAlertMessage("Flight record saved successfully.");
        setPage("Delay Details");
        if (MaintDncId !== '') {
          setSourceValue("M&E");
          setEnableDeleteBtn(true);
        }
       
        onSaveFlightDelayDetail(response)
 
        const updateDelayCodeModel: UpdateDelayCodeModel = {
          FlightSegmentId: flightdelaydetail.FlightSegmentId,
          DelayCode: flightdelaydetail.DelayCode,
          DelayReason: flightdelaydetail.DiscrepancyComments,
          // Convert HH:MM format to total minutes
          DelayMinutes: flightdelaydetail.LengthOfDelay ? (() => {
            // Ensure consistent format with padding
            const paddedDelay = flightdelaydetail.LengthOfDelay.padStart(5, '0');
            // Extract hours and minutes from the HH:MM format
            const hours = parseInt(paddedDelay.substring(0, 2), 10);
            const minutes = parseInt(paddedDelay.substring(3, 5), 10);
            // Convert to total minutes
            return (hours * 60) + minutes;
          })() : 0,
        }
        //update the delay code
        UpdateDelayCode(getAccessToken(), updateDelayCodeModel)
          .then((response) => {
            console.info(response);
            console.info(response);
 
          })
          .catch((error) => {
            console.log(error);
          })
 
 
      })
      .catch((error) => {
        console.log(error);
        setAlertType("error");
        setAlertMessage(extractDetailsFromErrorMessage(error));
        setPage("Delay Details");
      })
      .finally(() => {
        setBusy(false);
        setIsapiresponsereceived(true);
      });  
  };
  const extractDetailsFromErrorMessage = (error: any): string => {
    try {
      const statusCodeMatch = RegExp(/Status Code : (\d+)/).exec(error);      if (statusCodeMatch) {
        const statusCode = parseInt(statusCodeMatch[1], 10);
        // Use a non-greedy match to extract JSON content
        const jsonStringMatch = RegExp(/({(?:[^{}]|\{[^{}]*\})*})/).exec(error);
        if (!jsonStringMatch) {
          return error.message;
        } else {
          const jsonString = jsonStringMatch[1];
          const errorMessage = JSON.parse(jsonString);
  
            const normalizedErrorMessage = Object.keys(errorMessage).reduce((acc, key) => {
                acc[key.toLowerCase()] = errorMessage[key];
                return acc;
            }, {} as { [key: string]: any });

            if (statusCode === 400 || statusCode === 500) {
                const errors = normalizedErrorMessage.errors ? JSON.stringify(normalizedErrorMessage.errors) : "Errors not found"; 
                return `Status Code: ${statusCode}, Errors: ${errors}`;
          } else {
            return error.message;
          }
        }
      } else {
        return error.message;
      }
    } catch (e) {
      return error.message;
    }
  };
  //Delete delay details function.
  const deletemaintdelay=  async (MaintDncId: string)  => {
    if(MaintDncId===undefined) { 
      setBusy(true);
      setIsapiresponsereceived(false);
      GetMaintDelays(getAccessToken(),stationvalue,delaycode,searchdatevalue,isNon737Tail?"HA":"AS")
      .then((response) => {
        if (response === undefined) {
          onError("No data found ");
        } else {
          const MaintValue=response[0].MaintDncId;
          console.log(response[0].MaintDncId);
            setBusy(false);
            setDeleteDialogOpen(false);
          onDelete(MaintValue,aircraftvalue,stationvalue,depflightvalue);
          closeDialog();

        }
      })
      .catch((error) => {
        console.log(error);
        setIsapiresponsereceived(true);
        setAlertType("error");
          setAlertMessage(extractDetailsFromErrorMessage(error));
        setPage("Delay Details");
      })
      .finally(() => {
        setBusy(false);        
      });
    }
    else {
        setDeleteDialogOpen(false); 
        onDelete(MaintDncId, aircraftvalue, stationvalue, depflightvalue);
        closeDialog();

    }
  };

  //Call confirm delete popup
  const callConfirmDeletePopup=()=>{
    setDeleteDialogOpen(true);
  }

  //Get arrival flight info from fltops.
  const getArrivalFlightInfo = (flightSegmentId: number) => {
    setBusy(true);
    setIsapiresponsereceived(false);
    GetArrivalFlightDetail(getAccessToken(), flightSegmentId)
    .then((response) => {

      setArrivalScheduledTime(response.ArrivalScheduledTime == null ? '0' : response.ArrivalScheduledTime.padStart(4, "0"));
      setArrivalActualTime( response.ArrivalActualTime == null ? '0' : response.ArrivalActualTime.padStart(4, "0"));
      setArrivalFlightNumber(response.FlightNumber == null ? "" : response.FlightNumber.padStart(4, "0"));
     
        if (response.AircraftReg !== undefined) {
         
          // setDepartureScheduledTime(response.DepartureScheduledTime == null ? "" : response.DepartureScheduledTime);
          // setDepartureActualTime(response.DepartureActualTime == null ? "" : response.DepartureActualTime);
          // setLengthOfDelay(response.LengthOfDelay == null ? "" : response.LengthOfDelay);
          // setinterrupttype(response.InterruptIndicator == null ? "F" : response.InterruptIndicator);
          // setMaintenanceInterruptComment(response.MaintenanceInterruptComment == null ? "" : response.MaintenanceInterruptComment);
          // setLogPageNumber(response.LogPageNumber == null ? "" : response.LogPageNumber);
          // setAtaChapter(response.AtaChapter == null ? "" : response.AtaChapter);          
          // setDiscrepancyComments(response.DiscrepancyComments == null ? "" : response.DiscrepancyComments);
          // setCorrectionComments(response.CorrectionComments == null ? "" : response.CorrectionComments);
          //setTraxFlightNumber(response.TraxFlightNumber ?? "");
          if (sourceValue === "FltOpsC") {
            setdelaycode("C1");          
          } else {
            setdelaycode("D01");
          }          
        }
      })
      .catch((error) => {
        console.log(error);
        setIsapiresponsereceived(true);  
         setAlertType("error");
          setAlertMessage(extractDetailsFromErrorMessage(error));
        setPage("Delay Details");
      })
      .finally(() => {
        setBusy(false);         
      });
  };

  //Get delay details from M&E.
  const getMaintDelayDetails = (date: string) => {   
    setLoadingMEData(true);
    setIsapiresponsereceived(false);
    GetMaintDelayDetail(getAccessToken(),MaintDncId)
    .then((response) => {
      if (response.AircraftReg !== undefined) {
        setArrivalScheduledTime((response.ArrivalScheduledTime && response.ArrivalScheduledTime.padStart(4, "0")) ?? "");
        setArrivalActualTime((response.ArrivalActualTime && response.ArrivalActualTime.padStart(4, "0")) ?? "");
        setArrivalFlightNumber((response.ArrivalFlightNumber && response.ArrivalFlightNumber.padStart(4, "0")) ?? "");
        setDepartureScheduledTime(response.DepartureScheduledTime ?? "");
        setDepartureActualTime((response.DepartureActualTime && response.DepartureActualTime.padStart(4, "0")) ?? "");
        setLengthOfDelay(response.LengthOfDelay ?? "");
        setinterrupttype(response.InterruptIndicator ?? "F");
        setMaintenanceInterruptComment(response.MaintenanceInterruptComment ?? "");
        setdelaycode(response.DelayCode);
        setFirstDelayInd(response.FirstDelayInd ?? "Y");
        setMechanicalFailInd(response.MechanicalFailInd ?? "Y");
        setLogPageNumber(response.LogPageNumber ?? "");
        setItemNumber(response.ItemNumber ?? "");
        initialLogPageNumberRef.current = response.LogPageNumber ?? "";
        initialItemNumberRef.current = response.ItemNumber ?? "";
        setAtaChapter(response.AtaChapter ?? "");
        setDiscrepancyComments(response.DiscrepancyComments ?? "");
        setCorrectionComments(response.CorrectionComments ?? "");
        setLastUpdatedOn(response.DateLastUpdated);
        setTraxFlightNumber(response.TraxFlightNumber ?? "");
        setFlightSegmentId(response.FlightSegmentId);
        setFlightSegIdPrev(response.FlightSegmentId);
        setIsInitiallyUncodedTraxRecord(
          (response.LogPageNumber == null || response.LogPageNumber.trim() === "") &&
          (response.ItemNumber == null || response.ItemNumber.trim() === "") &&
          (response.AtaChapter == null || response.AtaChapter.trim() === "") &&
          (response.DiscrepancyComments == null || response.DiscrepancyComments.trim() === "") &&
          (response.CorrectionComments == null || response.CorrectionComments.trim() === "") &&
          (response.TraxFlightNumber == null || response.TraxFlightNumber.trim() === "")
        );
        if(response.REPORT_UPDATED_PEOPLESOFTID!==null){
        setLastUpdatedBy(response.REPORT_UPDATED_GIVENNAME + " " + response.REPORT_UPDATED_FAMILYNAME +"("+response.REPORT_UPDATED_PEOPLESOFTID+")");
        }
        else{
          setLastUpdatedBy(response.ReportedUpdatedBy);
        }
        // Need to fix data column to non-nullable, as the date should not be null
        // if the record exists. Since it is currently nullable, handle accordingly.
        const shortDate = extractDatePart(response.FlightDate);
        if (shortDate) setSearchDateValue(shortDate);
        //get the Visops DELAY or CANCEL code from FlightOps
        getFltopsDelayData(response.FlightSegmentId);
      } else {
        setArrivalFlightNumber("");
        setArrivalScheduledTime("");
        setArrivalActualTime("");
        setDepartureScheduledTime("");
        setDepartureActualTime("");
        setLengthOfDelay("");
        setinterrupttype("F");
        setMaintenanceInterruptComment("");
        setdelaycode("D01");          
        setFirstDelayInd("Y");
        setMechanicalFailInd("Y");
        setLogPageNumber("");
        setItemNumber("");
        setAtaChapter("");
        setDiscrepancyComments("");
        setCorrectionComments("");
        setTraxFlightNumber("");
        setIsInitiallyUncodedTraxRecord(true);
        console.log(response);
      }
      if (Object.keys(response).length === 0) {
        setIsapiresponsereceived(true);
        setAlertType("error");
        setAlertMessage("No record exists.Please refresh the page");
        setPage("Delay Details");
        setSourceValue('');
        setEnableDeleteBtn(false);
      }
    })
  
      .catch((error) => {
        console.log(error);  
        setIsapiresponsereceived(true);
        setAlertType("error");
          setAlertMessage(extractDetailsFromErrorMessage(error));
        setPage("Delay Details");
      }) 
      .finally(() => {
        setLoadingMEData(false);   
      });
  };

  // Get delay details from FlightOps
const getFltopsDelayData = (flightSegmentId:number) => {
  setBusy(true);
  setIsapiresponsereceived(false);
  GetFltopsDelayData(getAccessToken(), flightSegmentId)
    .then((response) => {
      console.log("GetFltopsDelayData response: ", response);
      if (response === undefined) {
        onError("No delaycodes found ");
      }    
      // First check if cancel_code exists for this flightsegment id
      // If yes display cancel code; else delay_code
      else if (response.cancel_code != null) {
        setFltopsC(response.cancel_code);
      }
      else if (response.delayminute != 0) {
        const hours = Math.floor(response.delayminute / 60);
        const minutes = response.delayminute % 60;
        
        if (response.delay_code != null) {
          setDelay(
            response.delay_code +
              " / " +
              `${hours.toString().padStart(2, "0")}:${minutes
                .toString()
                .padStart(2, "0")}`
          );
          console.log(response);
        }
      }
    }) 
    .catch((error) => {
      console.log(error);
      setIsapiresponsereceived(true);
      setAlertType("error");
      setAlertMessage(extractDetailsFromErrorMessage(error));
      setPage("Delay Details");
    })
    .finally(() => {
      setBusy(false); 
    });
  };
  
  //Compare Trax comments with M&E comments
  const CompareTraxData = () => {
    console.log('CompareTraxData called:', { isNon737Tail, itemNumber, logPagenumber, manufacturerCode });
    // For non-737, require item number before retrieving defect info
    // isNon737Tail=true means non-737 (requires item number), isNon737Tail=false means 737 (no item number)
    if (isNon737Tail === true && (!itemNumber || itemNumber.trim() === "")) {
      setIsLogPageValid(true);
      setTraxCommentMismatch(false);
      setIsTraxCompareInProgress(false);
      return;
    }

    //call ValidateLogPageNumber
      setIsapiresponsereceived(false);
      pendingCompareRequestsRef.current += 1;
      setIsTraxCompareInProgress(true);
      const requestId = ++compareRequestIdRef.current;
      const requestedInputs = { logPagenumber, manufacturerCode, itemNumber };
  
    ValidateLogPageNumber(getAccessToken(), logPagenumber, manufacturerCode, itemNumber)
      .then((response) => {
        const latest = latestCompareInputsRef.current;
        const isStaleResponse =
          requestId !== compareRequestIdRef.current ||
          latest.logPagenumber !== requestedInputs.logPagenumber ||
          latest.manufacturerCode !== requestedInputs.manufacturerCode ||
          latest.itemNumber !== requestedInputs.itemNumber;

        // Ignore out-of-order responses so older calls cannot overwrite newer user input.
        if (isStaleResponse) {
          return;
        }

        console.log(response);
        if (response.LogTailNbr !== undefined && response.LogTailNbr !== null && response.LogTailNbr !=="") {  
          setIsLogPageValid(true);
          setDefectType(response.DefectType || ""); // <-- Set defectType from API response

          const hasNoExistingCodedTraxValues =
            toTrimmedString(atachapter) === "" &&
            toTrimmedString(discrepancycomments) === "" &&
            toTrimmedString(correctioncomments) === "" &&
            toTrimmedString(traxFlightNumber) === "";
          const isBrandNewRecord = toTrimmedString(MaintDncId) === "";

          // For records initially loaded without log/item coding, immediately hydrate
          // remarks/ATA/flight from TRAX once valid log+item is entered.
          if ((isInitiallyUncodedTraxRecord || isBrandNewRecord) && hasNoExistingCodedTraxValues) {
            setDiscrepancyComments(response.LogDiscRmk ?? "");
            setCorrectionComments(response.LogDefRmk ?? "");
            setAtaChapter(response.ATAChapter ?? "");
            setTraxFlightNumber(response.Flight ?? "");
            setTraxCommentMismatch(false);
            setIsInitiallyUncodedTraxRecord(false);
            initialLogPageNumberRef.current = logPagenumber;
            initialItemNumberRef.current = itemNumber;
            return;
          }

          // User changed the log/item from what was originally loaded — hydrate comments from TRAX
          const logChanged = logPagenumber.trim() !== initialLogPageNumberRef.current.trim();
          const itemChanged = itemNumber.trim() !== initialItemNumberRef.current.trim();
          if (logChanged || itemChanged) {
            console.log('CompareTraxData: Log/item changed from original, hydrating from TRAX', { logChanged, itemChanged });
            setDiscrepancyComments(response.LogDiscRmk ?? "");
            setCorrectionComments(response.LogDefRmk ?? "");
            setAtaChapter(response.ATAChapter ?? "");
            setTraxFlightNumber(response.Flight ?? "");
            setTraxCommentMismatch(false);
            initialLogPageNumberRef.current = logPagenumber;
            initialItemNumberRef.current = itemNumber;
            return;
          }

             const normalizedLogStatus = toTrimmedString(response.LogStatus).toUpperCase();
             const normalizedLogDiscRmk = toTrimmedString(response.LogDiscRmk).replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ').trim();
             const normalizedDiscrepancyComments = toTrimmedString(discrepancycomments).replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ').trim();
             const normalizedLogDefRmk = toTrimmedString(response.LogDefRmk).replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ').trim();
             const normalizedCorrectioncomments = toTrimmedString(correctioncomments).replace(/\r?\n|\r/g, ' ').replace(/\s+/g, ' ').trim();
             const normalizedAtaChapter = toTrimmedString(response.ATAChapter);
             const normalizedCurrentAtaChapter = toTrimmedString(atachapter);
          
          
          if ((normalizedLogDiscRmk !== normalizedDiscrepancyComments
           || normalizedLogDefRmk!== normalizedCorrectioncomments || normalizedAtaChapter !== normalizedCurrentAtaChapter) && normalizedLogStatus === 'C') {
              console.log('CompareTraxData: ✓ MISMATCH DETECTED (LogStatus=C), setting orange = TRUE');
              setTraxCommentMismatch(true);
            }   
            else {
              console.log('CompareTraxData: ✗ No mismatch detected or LogStatus !== C, setting orange = FALSE');
              setTraxCommentMismatch(false);
            }                     
        }
        else{
          setIsLogPageValid(false);
          setTraxCommentMismatch(false); //no need to alert if log page is invalid
          
        }
    })
    .catch((error) => {
        const latest = latestCompareInputsRef.current;
        const isStaleError =
          requestId !== compareRequestIdRef.current ||
          latest.logPagenumber !== requestedInputs.logPagenumber ||
          latest.manufacturerCode !== requestedInputs.manufacturerCode ||
          latest.itemNumber !== requestedInputs.itemNumber;

        if (isStaleError) {
          return;
        }
        console.log(error);
        setIsapiresponsereceived(true);
        setAlertType("error");
        setAlertMessage(extractDetailsFromErrorMessage(error));
        setPage("Delay Details");
    })
    .finally(() => {
      pendingCompareRequestsRef.current = Math.max(0, pendingCompareRequestsRef.current - 1);
      if (pendingCompareRequestsRef.current === 0) {
        setIsTraxCompareInProgress(false);
      }
    });
  };

  //*******Handlers********

  //Handle mechanical failure radio group change.
  const handleMechanicalfailindGroup = (e: any) => {
    const { target } = e;
    setMechanicalFailInd(target.value);
  };

  //Handle first delay radio group change.
  const handleFirstDCFailureGroup = (e: any) => {
    const { target } = e;
    setFirstDelayInd(target.value);
  };

  //Cancel button handler.
  const cancelForm = () => {
    onCancel();
  };

  // Function to format `lastUpdatedOn` to local timezone in shortened format
  const formatToLocalShortDateTime = (dateString: string): string => {
    if (!dateString) return "";
    // If ISO string without Z or milliseconds, treat as UTC
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(dateString)) {
      return new Date(dateString + 'Z').toLocaleString();
    }
    // If ISO string with milliseconds and/or Z, treat as UTC
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d+(Z)?$/.test(dateString)) {
      return new Date(dateString).toLocaleString();
    }
    // If ISO string with Z or offset, parse normally
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:?\d{2})$/.test(dateString)) {
      return new Date(dateString).toLocaleString();
    }
    // Otherwise, assume already local and display as-is
    return dateString;
  };

  useEffect(() => {
    if (lastUpdatedOn) {
      const formattedDate = formatToLocalShortDateTime(lastUpdatedOn);
      setFormattedLastUpdatedOn(formattedDate);
    }
  }, [lastUpdatedOn]);

  const isAdminUser = getAdminStatus().value;
  const isMaintainerUser = getMaintainerStatus().value;
  const showLastUpdatedInfo =
    sourceValue !== "FltOpsC" &&
    sourceValue !== "FltOpsD" &&
    lastUpdatedBy &&
    formattedLastUpdatedOn &&
    MaintDncId;

  const getDelayBadgeText = () => {
    if (!isAdminUser) {
      return "";
    }
    if (delay) {
      return `VISOPS Delay: ${delay}`;
    }
    if (fltopsC) {
      return `VISOPS Cancel: ${fltopsC}`;
    }
    return "";
  };

  const renderTraxLogSection = () => {
    if (airlineCode) {
      return (
        <TraxLogInfo
          data-testid="traxLogInfo"
          showLoader={loadingMEData}
          fleetInput={fleet}
          manufacturer={manufacturerCode}
          mechanicalfailindInput={mechanicalfailind}
          logValidationChanged={(isValid: boolean) => setIsLogPageValid(isValid)}
          logPageNumberInput={logPagenumber}
          logPageNumberChanged={(logPageNumber: string) => setLogPageNumber(logPageNumber)}
          itemNumberInput={itemNumber}
          itemNumberChanged={(itemNum: string) => setItemNumber(itemNum)}
          onItemFocusChanged={(focused: boolean) => setIsItemFocused(focused)}
          onLogFocusChanged={(focused: boolean) => setIsLogFocused(focused)}
          isNon737Tail={isNon737Tail}
          ataChapterInput={atachapter}
          ataChapterChanged={(ataChapter: string) => setAtaChapter(ataChapter)}
          discrepancyCommentsInput={discrepancycomments}
          discrepancycommentsChanged={(discrepancyComments: string) => setDiscrepancyComments(discrepancyComments)}
          correctioncommentsInput={correctioncomments}
          correctioncommentsChanged={(correctionComments: string) => setCorrectionComments(correctionComments)}
          traxFlightNumberInput={traxFlightNumber}
          traxFlightNumberChanged={(traxFlightNumber: string) => setTraxFlightNumber(traxFlightNumber)}
          traxDataMismatch={traxCommentMismatch}
          onClearTraxMismatch={() => {
            setTraxCommentMismatch(false);
          }}
onRefreshComplete={() => {
  // Re-run compare after refresh completes to detect if mismatch still exists.
  // Defer to ensure state updates from hydration are applied before comparing.
  setTimeout(() => {
    CompareTraxData();
  }, 0);
}}
          compareInProgress={isTraxCompareInProgress}
          isLogPageValid={isLogPageValid}
          defectType={defectType}
          defectTypeChanged={setDefectType}
          onClickSave={onSaveFieldValidations}
        />
      );
    }
    if (isAircraftValid) {
      return <div className="loader"><auro-loader orbit></auro-loader></div>;
    }
    return null;
  };

  const renderDeleteButton = () => {
    if (!isAdminUser) {
      return null;
    }
    return (
      <button
        data-testid="btnDelete"
        id="btnDelete"
        className="red-slim-button"
        disabled={sourceValue === '' || sourceValue ==='FltOpsC' || sourceValue ==='FltOpsD' || !enableDeleteBtn}
        onClick={() => callConfirmDeletePopup()}
      >
        Delete
      </button>
    );
  };

  const renderDeleteDialog = () => {
    if (!isAdminUser) {
      return null;
    }
    return (
      <DCDialog
        open={openDeleteDialog}
        header="Delete Delay Details"
        size="sm"
        onclose={() => setDeleteDialogOpen(false)}>
        <ConfirmDeletePopUp
          id={MaintDncId}
          text={"Do you want to Delete this record with A/C: "+ aircraftvalue +", STN: " + stationvalue+ ", Flt Nbr: " + depflightvalue+ "?"}
          page="Delay Details"
          onDelete = {(id: string) => deletemaintdelay(id) }
          onCancel={ () => setDeleteDialogOpen(false) }/>
      </DCDialog>
    );
  };

  //*********Render*********
  
  return (
    <>
  {showLastUpdatedInfo && (
          <div className="lastUpdate">
            Last updated by empl: {lastUpdatedBy} on {formattedLastUpdatedOn}
          </div>
      )}
      <div className="Form" style={{ backgroundColor: "#dae3ec" }}>
      <span slot="content" className="custom-content">         
      <div className="FlexSingleColumn" style={{ marginTop: ".75rem", marginBottom: ".5rem" }}>
        {/* 
          Flight Identifier  
            - Departure Station
            - Aicraft
            - DEparture Flight Number
            - Dearture Shceduled Flight Date
        */}
        <div className="FlexSingleRow FullSize">
          <DCInput
            value={stationvalue}
            maxLength={3}
            placeholder="Station"
            required={true}
            disable={false}
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setStationValue(e.currentTarget.value.toUpperCase())
            }
            onClickSave={onSaveFieldValidations}
          />
          <AircraftInput
            value={aircraftvalue}   
            aircraftList={aircraftList || []} 
            onStartValidation={() => {
              setBusy(true);
              setIsAircraftValid(true);
              setAirlineCode("");}
            }
            onCompleteValidation={(isValid: boolean, isAPIError:boolean,aircraft?: AircaftData,apiError?:string) => {
              setIsAircraftValid(isValid);
              setHasAircraftValidationApiError(isAPIError);
              if (aircraft) {
                setAirlineCode(aircraft.airlineCode);
                setIsNon737Tail(aircraft.IsHaTail);
                if (aircraft.IsHaTail) {
                  setManufacturerCode("HA");                    
                } else {
                  switch (aircraft.manufacturerId) {
                    case 1:
                      setManufacturerCode("AS");
                      break;
                    }                  
                }
                    setManufacturerId(aircraft.manufacturerId);
                    setAircraftValue(aircraft.aircraftReg.length === 6 ? aircraft.aircraftReg.substring(1, 6) : aircraft.aircraftReg);
                    setfleet(aircraft.manufacturerId.toString());
              }
              if (apiError) {
                setAlertType("error");
                setAlertMessage(
                  "It looks like there was an API error. Please close the window and try again. " + 
                  extractDetailsFromErrorMessage(apiError)
                );
                setPage("Delay Details");
              }
              setBusy(false);
            }}/>          
          <DCInput
            value={depflightvalue}
            maxLength={4}
            placeholder="Flt Nbr"
            required={true}
            disable={sourceValue !==""}
            inputMode="numeric"
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDepFlightValue(e.currentTarget.value)
            }
            onClickSave={onSaveFieldValidations}
          />
          {/*a workaround to prevent the DCDatePicker from getting the focus when the page is re rendered*/}
          <input style={{ display: 'none' }} readOnly />
          <DCDatePicker
          data-testid="dcDatePicker"
            placeholder="Date"
            value={searchdatevalue}
            onBlur={handleBlurForDate}
            disabled={sourceValue !== "" }
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setSearchDateValue(e.currentTarget.value)
            }
          />
            {getAdminStatus().value && (
          <DCInput
            value={flightSegmentId.toString()}
            maxLength={38}
            placeholder="Flt Seg Id"
            required={false}
            disable={false}
            inputMode="numeric"
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFlightSegmentId(Number(e.currentTarget.value))
            }
          />)}
          {/* Adding 2 columns at the end */}
          <div></div>
        </div>
      </div>
      <div className="horizontal-line"></div>

      {/* Flight Information:
          - Arrival Information: Arrival Flight Number, Arrival Scheduled Time, Arrival Actual Time
          - Departure Information: Departure Flight Number, Departure Scheduled Time, Departure Actual Time
          - Delay Information: Delay Code, Interrupt Type, Length of Delay.
          - Question: Did a system on this aircraft have a mechanical fault/failure?
          - Question: Is this the first delay for this aircraft?
          - Comments
       */}
      <div className="FlexSingleColumn" style={{ marginTop: ".75rem", marginBottom: ".5rem" }}>
        <div className="FlexSingleRow FullSize" style={{ marginBottom: ".25rem" }}>
          <DCInput
            value={arrivalflightnumber}
            maxLength={4}
            placeholder="Arrv Flt"
            required={true}
            disable={busy}
            inputMode="numeric"
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setArrivalFlightNumber(e.currentTarget.value)
            }
            onClickSave={onSaveFieldValidations}
            />
          <DCInput
            value={arrivalscheduledtime}
            maxLength={4}
            inputMode="numeric"
            placeholder="Arrv Skd Time"
            required={false}
            disable={busy}            
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setArrivalScheduledTime(e.currentTarget.value)
            }
            pattern={flightTimePattern}
            validationMessage={flightTimeValidationMessage}
            onValidityChange={(isValid) => handleValidityChange('arrivalscheduledtime', isValid)}
            onClickSave={onSaveFieldValidations}
            />
          <DCInput
            value={arrivalactualtime}
            maxLength={4}
            inputMode="numeric"
            placeholder="Arrv Act Time"
            required={false}
            disable={busy}            
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setArrivalActualTime(e.currentTarget.value)
            }
            pattern={flightTimePattern}
            validationMessage={flightTimeValidationMessage}
            onValidityChange={(isValid) => handleValidityChange('arrivalactualtime', isValid)}
            onClickSave={onSaveFieldValidations}
            />
          <DCInput
            value={depflightvalue}
            maxLength={4}
            placeholder="Departing Flt"
            required={true}
            disable={sourceValue !== ""}
            inputMode="numeric"
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDepFlightValue(e.currentTarget.value)
            }
            onClickSave={onSaveFieldValidations}
            />
          <DCInput
            value={departurescheduledtime}
            maxLength={4}
            placeholder="Departing Skd Time"
            required={false}
            disable={busy}
            inputMode="numeric"
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDepartureScheduledTime(e.currentTarget.value)
            }
            pattern={flightTimePattern}
            validationMessage={flightTimeValidationMessage}
            onValidityChange={(isValid) => handleValidityChange('departurescheduledtime', isValid)}
            onClickSave={onSaveFieldValidations}
            />
          <DCInput
            value={departureactualtime}
            maxLength={4}
            placeholder="Departing Act Time"
            required={false}
            disable={busy}
            inputMode="numeric"
            onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setDepartureActualTime(e.currentTarget.value)
            }
            pattern={flightTimePattern}
            validationMessage={flightTimeValidationMessage}
            onValidityChange={(isValid) => handleValidityChange('departureactualtime', isValid)}
            onClickSave={onSaveFieldValidations}
            />
        </div>

        <div
          className="FlexSingleRow FullSize"
          style={{ marginBottom: ".25rem" }}
        >
          <div
            className="FlexSingleRow FullSize"
            style={{ marginRight: "-.35rem", marginLeft: "0" }}
          >
            <DCSelect
              placeholder="Delay code"
              options={(delaycodemodel || []).reduce(
                (acc: any, cur: any) => ({ ...acc, [cur.DelayCode]: cur.Description }),
                {}
              )}
              value={delaycode}
              disable={busy ? true : false}
              onInputChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                setdelaycode(e.currentTarget.value)
              }
              showErrorMsg={showDCCodeAlert}
              errMsg={delayCodeMessage}
            />
          </div>

          <div className="FlexSingleRow">
            <div
              style={{
                width: "67%",
                marginRight: "-1.3rem",
                marginLeft: ".4rem",
              }}
            >
              <DCSelect
                placeholder="Interrupt Type"
                options={{
                  F: "MTCE",
                  B: "Block Turnback",
                  C: "Aborted T/O",
                  A: "Air Turnback",                
                  D: "Diversion",   
                }}
                value={interrupttype}
                disable={busy ? true : false}
                onInputChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  setinterrupttype(e.currentTarget.value)
                }
                showErrorMsg={false}
                errMsg={""}
              />
            </div>

            <div style={{ width: "33%", marginLeft: "1.65rem", marginRight: "0" }}>
              <DCInput
                value={lengthofdelay}
                maxLength={5}
                placeholder="Delay Time"
                required={true}
                disable={busy}
                pattern={lengthofdelayPattern}
                validationMessage="Please enter a valid time in HH:MM format"
                onInputChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setLengthOfDelay(e.currentTarget.value)
                }
                onClickSave={onSaveFieldValidations}
                />
            </div>
          </div>
        </div>
        <div className="FlexSingleRow">
          <div className="FlexSingleRow FullSize CustomRadioGroup" style={{ width: "75%" }}>
            <auro-radio-group 
              horizontal 
              required 
              ref={mechanicalfailindGroupEl} 
              disabled={busy ? "disabled" : undefined}>
              <span slot="legend">
                Did a system on this aircraft have a mechanical
                fault/failure?
              </span>
              <auro-radio
              data-testid="myesRadio"
                role="mradio"
                id="yes1"
                label="Yes"
                name="Yes"
                value="Y"
                checked={mechanicalfailind === "Y" ? "checked" : undefined}>
              </auro-radio>
              <auro-radio
              data-testid="mnoRadio"
                role="mradio"
                id="no1"
                label="No"
                name="No"
                value="N"
                checked={mechanicalfailind === "N" ? "checked" : undefined}>
              </auro-radio>
            </auro-radio-group>
            <auro-radio-group
              role="firstdcradiogroup"
              id="FirstDelayOption"
              horizontal
              required
              ref={firstdelayindGroupEl}
              disabled={busy ? "disabled" : undefined}>
              <span slot="legend">
                Is this the first delay or cancel charged to this
                fault/failure?
              </span>
              <auro-radio
              data-testid="fyesRadio"
                role="fradio"
                id="yes2"
                label="Yes"
                name="firstdelay"
                value="Y"
                //checked
                checked={firstdelayind === "Y" ? "checked" : undefined}
              ></auro-radio>
              <auro-radio
              data-testid="fnoRadio"
                role="fradio"
                id="no2"
                label="No"
                name="notfirstdelay"
                value="N"
                checked={firstdelayind === "N" ? "checked" : undefined}
              ></auro-radio>
            </auro-radio-group>
          </div>

          <div className="badge badgeColor">
            {" "}{getDelayBadgeText()}
          </div>
        </div>
        <div
          className="FlexSingleRow FullSize"
          style={{ marginBottom: ".25rem" }}
        >
          <DCTextArea
            maxLength={750}
            value={maintenanceinterruptcomment}
            placeholder={"Comments"}
            required={interrupttype === "E" ? true : false}
            disable={busy ? true : false}
            spellcheck={false}
            onInputChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
              setMaintenanceInterruptComment(e.currentTarget.value)
            }
            onClickSave={onSaveFieldValidations}
          />
        </div>
      </div>

      {/* Trax Log Information:
          - Log Page Number
          - ATA Chapter
          - Discrepancy Comments
          - Correction Comments
       */}
      <div className="horizontal-line"></div>
      {renderTraxLogSection()}
      </span>
      <span slot="footer"  className="custom-footer">         
      <div className="DelayEntryFooter" style={{ marginTop: ".25rem", marginBottom: ".25rem" }}>
        <auro-button
        data-testid="btnCancel"
          slim
          secondary
          id="btnCancel"
          slot="trigger"
          onClick={() => cancelForm()}
        >
          Cancel
        </auro-button>
        <auro-button
        data-testid="btnSave"
          slim          
          hidden={!isAdminUser && !isMaintainerUser ? "hidden" : undefined}
          disabled={
            busy || !airlineCode || !manufacturerId ? "disabled" : undefined
          }
          onClick={() => checkValidations()}
        >
          Save
        </auro-button>
      </div>

      
      <div
        className="DelayEntryDelete"
        style={{ marginTop: "-2.75rem"  }}
      >
      {renderDeleteButton()}
      </div> 

      {(isapiresponsereceived || hasAircraftValidationApiError) && (
        <div className="ComponentAlerts CustomAlert">
          <Alert
            page={page}
            message={alertMsg}
            type={alertType}
            onClose={() => {setHasAircraftValidationApiError(false)}}
          ></Alert>
        </div>
      )}
  </span> 
{renderDeleteDialog()} 
     </div>
    </>
    
  );
};
